import React, { useState } from 'react';
import { getBusinessTypeNames, getMissingDocuments, openRegistrationDocument } from '../utils/registrationDocuments';

// Daftar bidang usaha sebuah pengajuan (dari embed registration_business_types).
// Untuk tampilan admin, jadi isian "Lainnya" ikut ditampilkan.
export const BidangUsahaList = ({ item }) => {
    const names = getBusinessTypeNames(item);

    if (names.length === 0) {
        return <span className="text-sm text-gray-500">-</span>;
    }

    return (
        <div>
            <ul className="space-y-1">
                {names.map((name) => (
                    <li key={name} className="text-sm text-gray-900">{name}</li>
                ))}
            </ul>
            {item.other_business_text && (
                <p className="mt-1 text-xs text-gray-500">Lainnya: {item.other_business_text}</p>
            )}
        </div>
    );
};

// Badan hukum, dokumen, dan penanda "Dokumen belum dilengkapi". Hanya untuk admin,
// tidak dipakai di halaman publik. Penanda hanya informasi dan tidak menghalangi persetujuan.
export const DokumenLegalitas = ({ item }) => {
    const [openingKey, setOpeningKey] = useState(null);
    const [error, setError] = useState('');
    const missing = getMissingDocuments(item);

    const handleOpen = async (key, url) => {
        setError('');
        setOpeningKey(key);
        try {
            await openRegistrationDocument(url);
        } catch (err) {
            setError(err.message);
        } finally {
            setOpeningKey(null);
        }
    };

    const renderDocument = (key, label, url) => (
        <div className="flex items-center gap-2">
            <span className="text-gray-500">{label}:</span>
            {url ? (
                <button
                    type="button"
                    onClick={() => handleOpen(key, url)}
                    disabled={openingKey === key}
                    className="text-blue-600 hover:text-blue-900 font-medium disabled:opacity-50 disabled:cursor-wait"
                >
                    {openingKey === key ? 'Membuka...' : 'Lihat'}
                </button>
            ) : (
                <span className="text-gray-400">belum ada</span>
            )}
        </div>
    );

    return (
        <div className="space-y-1 text-sm text-gray-900">
            <div>
                <span className="text-gray-500">Badan hukum:</span> {item.legal_entity_type || 'belum diisi'}
            </div>
            {item.legal_entity_type === 'Yayasan' && (
                <div className="text-xs text-gray-600 space-y-0.5">
                    <div>Nomor akta: {item.deed_number || '-'}</div>
                    <div>Notaris: {item.notary_name || '-'}</div>
                    <div>Nomor SK: {item.sk_number || '-'}</div>
                </div>
            )}
            {renderDocument('akta', 'Akta atau SK', item.document_url)}
            {renderDocument('kemenag', 'Izin Kemenag', item.kemenag_document_url)}
            {missing.length > 0 && (
                <div className="pt-1">
                    <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                        Dokumen belum dilengkapi
                    </span>
                    <p className="mt-1 text-xs text-gray-500">Belum ada: {missing.join(', ')}</p>
                </div>
            )}
            {error && <p className="text-xs text-red-600">{error}</p>}
        </div>
    );
};
